import Template from 'backbone/platform/templates/assets/picker_asset_view.js.hamlc'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class AssetPickerAssetView extends Backbone.View
  className: "thumbnail-asset-wrapper"

  events:
    "click .asset-image"            : "toggleSelected"
    "click .asset-information-tint" : "toggleSelected"
    "click .asset-filename"         : "toggleSelected"

  initialize: (options) ->
    @dispatcher = BackboneDispatcher.get_instance()
    @asset = options.asset
    @listenTo(@asset, "change", @render)
    @clickCallback = options.clickCallback

  toggleSelected: (e) ->
    if @clickCallback
      @clickCallback(e, @asset)
    else
      @asset.toggleSelected()
      @dispatcher.trigger("assetChanged")
      contently.ui.closeTooltip(e)

  render: ->
    @$el.html Template(asset: @asset)
    @_updateSelectedClass()
    this

  _updateSelectedClass: ->
    if @asset.get("selected")
      @$el.addClass "selected"
    else
      @$el.removeClass "selected"



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/asset_picker_asset_view.js.coffee